import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, SUB_TITLES, TITLES, WARNINGS } from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { ApiMasters } from "apihandlers//masters/masters";
import { NOTIFY } from "common/config";
const ApiReportsHandler = new ApiReports();
const ApiMastersHandler = new ApiMasters();

const CustomerSupplierBrokerLedger = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<any>({});
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "date",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DATE,
      width: "15%",
    },
    {
      key: "description",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DESCRIPTION,
      width: "20%",
    },
    {
      key: "debit",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DEBIT,
      width: "20%",
    },
    {
      key: "credit",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CREDIT,
      width: "20%",
    },
    {
      key: "balance",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BALANCE,
      width: "20%",
      renderSum: true,
    },
  ];
  useEffect(() => {
    if (loading) {
      getMasterData();
    }
  }, [loading]);

  const getMasterData = () => {
    const args = { minResponse: true };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const customerId = masterRef.current.selectedValue.id;
    const customerName = masterRef.current.selectedValue.label;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.BROKER +
        ": " +
        customerName +
        "\n" +
        "From Date: " +
        fromDt +
        "\n" +
        "To Date: " +
        toDt
    );
    const args = {
      fromDt,
      toDt,
      customerId,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    setChartData(null);
    setRows(null);
    ApiReportsHandler.getCustomerSupplierBrokerLedger(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const list = response.rows;
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const masterRef: any = useRef();

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.CUSTOMER_SUPPLIER_BROKER_LEDGER}</li>
        </ul>
        <h4>{TITLES.CUSTOMER_SUPPLIER_BROKER_LEDGER}</h4>
        <p className="SubTitles">
          {SUB_TITLES.CUSTOMER_SUPPLIER_BROKER_LEDGER}
        </p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 5,
                marginBottom: 10,
                width: "40%",
              }}
            >
              <label>{LABELS.SELECT_CUSTOMER_SUPPLIER_BROKER_LEDGER}</label>
              <AutoComplete
                id={"masters"}
                list={masters}
                childRef={masterRef}
              />
            </div>
            <div
              className="formGroup"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"customerSupplierBrokerLedger"}
              title={LABELS.CUSTOMER_SUPPLIER_BROKER_LEDGER}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(CustomerSupplierBrokerLedger);
